module.exports = __webpack_public_path__ + "static/media/supplier-collage@3x.31b4a02d.webp";